/** @type {Promise<typeof import('../modules/imageSlider.js')>|null} */
let modulePromise = null;

/**
 * Serialized initialization queue.
 * Each slider waits for the previous one to fully initialize and the browser to complete
 * a layout pass before the next one starts.
 * @type {Promise<void>}
 */
let initChain = Promise.resolve();

/** @param {HTMLElement} sliderElement */
function initSlider(sliderElement) {
    modulePromise ??= import('../modules/imageSlider.js').catch((error) => {
        modulePromise = null;
        throw error;
    });

    initChain = initChain
        .then(() => modulePromise)
        .then(({ImageSlider}) => {
            new ImageSlider({slider: sliderElement});
            return new Promise((resolve) => requestAnimationFrame(resolve));
        });
}

/**
 * Lazily initializes image sliders when they enter the viewport.
 * Sliders inside collapsed accordions (<details>) won't be initialized
 * until the accordion opens and the slider becomes visible.
 */
function observeSliders() {
    const sliders = document.querySelectorAll('[data-image-slider]');

    if (sliders.length === 0) {
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                initSlider(entry.target);
            }
        }
    }, {rootMargin: '200px 0px'});

    sliders.forEach((slider) => observer.observe(slider));
}

document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', observeSliders)
    : observeSliders();
